/**
 * Different types of user who wants to report an absence.
 */
export enum UserFunctionEnumeration {
	BROKER = 'broker',
	REPRESENTATIVE = 'representative',
	EMPLOYER = 'employer',
}
